class Order {
	static getDinamicOrderItem (order, media_type="all") {
		// This method returns the first dynamic product of the order.
		// It used to work because there could be only one fixed the dinamic product on the website.
		// Now, we can have more, and this method may get deprecated soon.
		const { items = [] } = order;
		const dinamicItem = items.find((item) => {
			let unitsCheck = item.product_type.unities !== 0
			let mediaTypeCheck = Order.checkProductTypeMediaType(item.product_type, media_type)
			return unitsCheck && mediaTypeCheck
		});
		return dinamicItem || {};
	};

	static getOrderItems(order, media_type="all"){
		const { items = [] } = order;
		const filteredItems= items.filter((item) => {
			let unitsCheck = item.product_type.unities !== 0
			let mediaTypeCheck = Order.checkProductTypeMediaType(item.product_type, media_type)
			return unitsCheck && mediaTypeCheck
		});
		return filteredItems
	}
	static getOnlineProductForMedia(onlineProducts, mediaType) {
		return (onlineProducts || []).find(
			(product) => product.unities !== 0
				&& Order.checkProductTypeMediaType(product, mediaType)
		);
	}

	static checkProductTypeMediaType(productType, mediaType){
		if (mediaType==="photo"){
			return productType.is_photo
		}
		else if (mediaType==="video"){
			return productType.is_video
		}
		return true
	};
	static getOrderAssociatedItems(order){
		const orderItems = Order.getOrderItems(order)
		const associatedItems = []
		orderItems.forEach(orderItem => orderItem.items.forEach(item => associatedItems.push(item)))
		return associatedItems
	}
	static productRequiresAssociatedMedia(productType) {
		if (!productType) return true;
		if (!productType.is_photo && !productType.is_video) return false;
		if (productType.ranges_price && productType.ranges_price.length > 0) return true;
		if (productType.unities < 0) return true;
		return true;
	}

	static isAllDigitalProductType(productType) {
		if (!productType || productType.unities !== 0) return false;
		return productType.is_photo || productType.is_video;
	}

	static getNonMediaOrderItems(order) {
		const { items = [] } = order;
		return items.filter(
			(item) => item.product_type && !Order.productRequiresAssociatedMedia(item.product_type)
		);
	}

	static canRemoveAssociatedItem(order, associatedItemId) {
		const orderItem = Order.getOrderItemByAssociatedItemId(order, associatedItemId);
		if (!orderItem || !orderItem.product_type) return true;
		return orderItem.product_type.can_remove !== false;
	}

	static canCheckout(order, photosLength = 0) {
		if (Order.getNonMediaOrderItems(order).length > 0) return true;
		return Order.getTotalOrderPhotos(order, photosLength) > 0;
	}

	static getDinamicOrderItemMedias (order) {
		const associatedItems = Order.getOrderAssociatedItems(order);
		return associatedItems ? associatedItems : [];
	};

	static getOrderItemByAssociatedItemId(order, associatedItemId){
		return order.items.find(orderItem => orderItem.items.find(item => item.id === associatedItemId))
	}

	static isMediaOnOrder (mediaId, order) {
		const associatedItems = Order.getOrderAssociatedItems(order);
		const media = associatedItems.find((item) => (item.photo && item.photo.id === mediaId) || (item.video && item.video.id === mediaId));

		return media !== undefined;
	}

	static getAssociatedItemIdFromMediaId (order, mediaId) {
		const associatedItems = Order.getOrderAssociatedItems(order);
		const { id } = associatedItems.find((item) => (item.photo && item.photo.id === mediaId) || (item.video && item.video.id === mediaId));

		return id;
	}

	static getOrderItemByProductId (order, productId) {
		const { items = [] } = order;
		return items.find((item) => item.product_type.id === productId);
	}

	static getOrderItemsByProductId(order, productId) {
		const { items = [] } = order;
		return items.filter((item) => item.product_type && item.product_type.id === productId);
	}

	static getProductQuantityOnOrder(order, productId) {
		return Order.getOrderItemsByProductId(order, productId).length;
	}

	static getLastOrderItemByProductId(order, productId) {
		const items = Order.getOrderItemsByProductId(order, productId);
		if (items.length === 0) {
			return null;
		}

		return items[items.length - 1];
	}

	static groupOrderItemsByProduct(order, items = order.items || []) {
		const groups = {};

		items.forEach((item) => {
			if (!item.product_type) return;

			const productId = item.product_type.id;

			if (!groups[productId]) {
				groups[productId] = {
					productType: item.product_type,
					quantity: 0,
					itemsCount: 0,
					total: 0,
					orderItems: [],
				};
			}

			groups[productId].quantity += 1;
			groups[productId].itemsCount += (item.items || []).length;
			groups[productId].total += parseFloat(item.total || item.product_type.price || 0);
			groups[productId].orderItems.push(item);
		});

		return Object.values(groups);
	}

	static groupNonMediaOrderItems(order) {
		return Order.groupOrderItemsByProduct(
			order,
			Order.getNonMediaOrderItems(order)
		);
	}

	static groupOrderItemsForCheckout(order) {
		return Order.groupOrderItemsByProduct(order);
	}

	static isProductOnOrder(productId, order) {
		return Order.getProductQuantityOnOrder(order, productId) > 0;
	}

	static hasAllDigital (order) {
		const { items: orderItems = [] } = order;

		return orderItems.some((orderItem) => (
			Order.isAllDigitalProductType(orderItem.product_type)
		));
	}

	static getTotalOrderPhotos (order, photosLength) {
		let hasAllDigital = Order.hasAllDigital(order);
		let total = 0;
		const { items: orderItems = [] } = order;

		orderItems.forEach((orderItem) => {
			const { items: associatedItems = [] } = orderItem;
			const { product_type } = orderItem;

			total = total + associatedItems.length;

			if (Order.isAllDigitalProductType(product_type) && !hasAllDigital) {
				hasAllDigital = true;
			}
		});

		if (hasAllDigital) {
			return photosLength;
		}

		return total
	}
}

export default Order;